export class DCCommunityPortalSRNotes {
    "Note": string = "";
    "Note Type": string = "";
}

export class ListOfDCCommunityPortalSRNotes {
    "DC Community Portal SR Notes" = null as DCCommunityPortalSRNotes[] | null;
}

export class DCCommunityPortalSR {
    "SR Number": string = "";
    "CSN": string = "";
    "SR Type": string = ""
    "Sub Type": string = "";
    "DC Payment Method": string = "Online";
    "DC Channel": string = "Online";
    "DC Processing Type": string = "";
    "DC ATA Reason": string = "";
    "DC Collection Option": string = "";
    "DC Additional Consignee Address": string = "";

    "DC Carnet Number": string = "";
    "ListOfDC Community Portal SR Notes": ListOfDCCommunityPortalSRNotes = new ListOfDCCommunityPortalSRNotes();
    "DC Building Name": string = "";
    "DC Area": string = "";
    "DC Emirates": string = "";
    "DC Courier Email Addr": string = "";
    "DC Courier Mobile": string = "";
}

export class ListOfDCCommunityPortalSRUpsertIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCIncomingHierarchy {
    "MessageId": string = "";
    "IntObjectName": string = "DC Community Portal SR Upsert IO";
    "MessageType": string = "Integration Object";
    "IntObjectFormat": string = "Siebel Hierarchical";
    "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIO = new ListOfDCCommunityPortalSRUpsertIO();
}

export class AtaReplaceSRBody {
    "ProcessName": string = "DC Community Portal SR Process Wrapper WF";
    "DCMethod": string = "SUBMIT";
    "DCLoginName": string = "";
    "DCLanguage": string = "ENU";
    "DCIncomingHierarchy": DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class AtaReplaceSRRequest {
    "body": AtaReplaceSRBody = new AtaReplaceSRBody();
}
